// extracted by mini-css-extract-plugin
export default {"desctiption":"style_desctiption__5ggMp","btns":"style_btns__J6NbY","link":"style_link__r-VVj","support":"style_support__GmlG1"};